import { Checkbox, Stack, TextField } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { DashBoardDateRangePicker } from "../..";

export const EmailLogListFilterSection = ({
  filter,
  onFilterChange,
  onOpenDateRangeSelection,
  onDateChangeApply,
}) => {
  const renderTags = (value, _) => <></>;

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <InputControl
        type="dropdown"
        name="type"
        label="Type"
        multiple={true}
        options={filter.options.types}
        value={filter.values.type}
        disableCloseOnSelect
        disableClearable={true}
        onChange={(_, value) => onFilterChange({ value, type: "type" })}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderTags={renderTags}
        renderOption={(props, option, { selected }) => (
          <li {...props} key={option.value}>
            <Checkbox style={{ marginRight: 8 }} checked={selected} />
            {option.label}
          </li>
        )}
        sx={{ maxWidth: "fit-content", minWidth: 200 }}
        // componentsProps={componentsProps}
        renderInput={(params) => (
          <TextField {...params} label="Type" placeholder="Type" />
        )}
      />
      <InputControl
        type="dropdown"
        name="status"
        label="Status"
        multiple={true}
        options={filter.options.Statuses}
        value={filter.values.status}
        disableCloseOnSelect
        disableClearable={true}
        onChange={(_, value) => onFilterChange({ value, type: "status" })}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderTags={renderTags}
        renderOption={(props, option, { selected }) => (
          <li {...props} key={option.value}>
            <Checkbox style={{ marginRight: 8 }} checked={selected} />
            {option.label}
          </li>
        )}
        sx={{ maxWidth: "fit-content", minWidth: 200 }}
        // componentsProps={componentsProps}
        renderInput={(params) => (
          <TextField {...params} label="Status" placeholder="Status" />
        )}
      />
      <DashBoardDateRangePicker
        isList={true}
        range={filter.date.value}
        showRange={filter.date.showDate}
        isOpen={filter.date.isCalenderOpen}
        handleIsOpen={onOpenDateRangeSelection}
        handleDateChangeApply={onDateChangeApply}
        position="left"
        onChangeDate={(event) => {
          onFilterChange({ value: event, type: "date_range" });
        }}
        label="Date Range"
      />
    </Stack>
  );
};
